import { NgModule } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

export type TiimeCheckboxChange = MatCheckboxChange;

@NgModule({
  imports: [MatCheckboxModule],
  exports: [MatCheckboxModule]
})
export class TiimeCheckboxModule {}
